import { render, staticRenderFns } from "./ImageDisplay.vue?vue&type=template&id=8d3e929a&scoped=true"
import script from "./ImageDisplay.vue?vue&type=script&lang=js"
export * from "./ImageDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3e929a",
  null
  
)

export default component.exports